
interface GalleryJson {
  id: string
  title: string
  text_color: string
  background_color: string
  total_uploads: number
  live_feed_enabled: boolean
}

export default class Config {
  enabled: boolean
  
  galleryCode: string
  galleryTitle: string
  galleryTextColor: string
  galleryBackgroundColor: string

  backgroundColor: string
  refreshMode: string
  recentLimit: number
  photoDelay: number
  cycleStartDelay: number
  cycleEndDelay: number
  featureNewImages: boolean
  autoLayout: boolean
  rows: number
  columns: number
  margin: number
  cyclesBetweenAds: number
  adDuration: number
  transition: string
  showOneAdPerCycle: boolean
  hideControls: boolean
  debug: boolean

  static DEFAULT_REFRESH_MODE = "screen"
  static DEFAULT_RECENT_LIMIT = 50
  static DEFAULT_ALL_LIMIT = 1000
  static DEFAULT_FEATURE_NEW_IMAGES = true
  static DEFAULT_PHOTO_DELAY = 0.1
  static DEFAULT_CYCLE_START_DELAY = 1
  static DEFAULT_CYCLE_END_DELAY = 5
  static DEFAULT_AUTO_LAYOUT = true
  static DEFAULT_ROWS = 2
  static DEFAULT_COLUMNS = 4
  static DEFAULT_CYCLES_BETWEEN_ADS = 2
  static DEFAULT_AD_DURATION = 5
  static DEFAULT_SHOW_ONE_AD_PER_CYCLE = true
  static DEFAULT_BACKGROUND_COLOR = "#000000"
  static DEFAULT_MARGIN = 1 // %
  static DEFAULT_TRANSITION = "scale"
  static DEFAULT_HIDE_CONTROLS = false

  constructor(gallery: GalleryJson) {

    this.debug = process.env.NODE_ENV === "development"
    if (this.debug) {
      console.log("Fetched gallery JSON: ", gallery)
    }

    this.enabled = gallery.live_feed_enabled

    this.galleryCode = gallery.id
    this.galleryTitle = gallery.title
    this.galleryTextColor = gallery.text_color
    this.galleryBackgroundColor = gallery.background_color

    this.backgroundColor = Config.DEFAULT_BACKGROUND_COLOR
    this.refreshMode = Config.DEFAULT_REFRESH_MODE

    this.recentLimit = Config.DEFAULT_RECENT_LIMIT

    this.photoDelay = Config.DEFAULT_PHOTO_DELAY
    this.cycleStartDelay = Config.DEFAULT_CYCLE_START_DELAY
    this.cycleEndDelay = Config.DEFAULT_CYCLE_END_DELAY

    this.featureNewImages = Config.DEFAULT_FEATURE_NEW_IMAGES
    this.transition = Config.DEFAULT_TRANSITION

    this.autoLayout = Config.DEFAULT_AUTO_LAYOUT
    this.rows = Config.DEFAULT_ROWS
    this.columns = Config.DEFAULT_COLUMNS
    this.margin = Config.DEFAULT_MARGIN

    this.cyclesBetweenAds = Config.DEFAULT_CYCLES_BETWEEN_ADS
    this.adDuration = Config.DEFAULT_AD_DURATION
    this.showOneAdPerCycle = Config.DEFAULT_SHOW_ONE_AD_PER_CYCLE

    this.hideControls = Config.DEFAULT_HIDE_CONTROLS
  }
}